export enum SavingTypes {
  GET_SAVING_NAME = "GET_SAVING_NAME",
  SAVING_NAME_SUCCESS = "SAVING_NAME_SUCCESS",
  FAILURE_NAME_SUCCESS = "FAILURE_NAME_SUCCESS",
  UPDATED_NAME_ID = "UPDATED_NAME_ID",
  UPDATE_SAVING_NAME = "UPDATE_SAVING_NAME",
  SET_EDITING_ID = "SET_EDITING_ID",
  UPDATE_LOADER = "UPDATE_LOADER",
}

export enum SharedLinesTypes {
  SHARED_LINES_STATUS = "SHARED_LINES_STATUS",
  SEND_INVITATION_INITIATED = "SEND_INVITATION_INITIATED",
  SET_INVITATION_INITIATED_RESPONSE = "SET_INVITATION_INITIATED_RESPONSE",
  SET_NEW_INVITATION_INITIATED_RESPONSE = "SET_NEW_INVITATION_INITIATED_RESPONSE",
  UPDATE_EMAIL_ALREADY_EXISTS = "UPDATE_EMAIL_ALREADY_EXISTS",
  RESET_INVITATION = "RESET_INVITATION",
  SET_LONG_RUNNING_QUERY = "SET_LONG_RUNNING_QUERY",
  RESET_TOAST_MESSAGE = "RESET_TOAST_MESSAGE",
  RESET_LANGUAGE_ERROR = "RESET_LANGUAGE_ERROR",
  SET_SHARED_ERROR = "SET_SHARED_ERROR",
}

export enum PairedLinesTypes {
  SET_PAIRED_LINE = "SET_PAIRED_LINE",
  RESET_PAIRED_LINE = "RESET_PAIRED_LINE",
  SET_LOADER = "SET_LOADER",
  SET_ERROR = "SET_ERROR",
  SET_ATTEMPTS = "SET_ATTEMPTS",
}
